import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ValuesBanner from "../../Assets/values-banner.webp";

import integrityImg from "../../Assets/integrity.jpg";
import transparencyImg from "../../Assets/transparency.jpg";
import customerImg from "../../Assets/customer-satisfactions.jpg";
import teamworkImg from "../../Assets/teamwork.jpg";
import corporateImg from "../../Assets/corporate-citizenship.jpg";
import innovationImg from "../../Assets/innovation.jpg";

import { Link } from "react-router-dom";

const OurValues = () => {
  const values = [
    {
      title: "Integrity",
      image: integrityImg,
      description:
        "Integrity is the foundation of everything we do at Khodiyar Industries. We conduct our business with honesty, accountability, and ethical practices while maintaining the highest standards of professionalism. We believe trust is earned through consistent actions and commitments.",
    },
    {
      title: "Transparency",
      image: transparencyImg,
      description:
        "We believe in maintaining transparency in all our business relationships. Open communication, fair dealings, and mutual trust help us build strong partnerships with our customers, suppliers, and stakeholders.",
    },
    {
      title: "Customer Satisfaction",
      image: customerImg,
      description:
        "Customer satisfaction is at the heart of our operations. We continuously strive to exceed customer expectations by delivering premium-quality automotive glass products, timely service, and reliable solutions.",
    },
    {
      title: "Teamwork",
      image: teamworkImg,
      description:
        "Our success is driven by the collective efforts of our team. We encourage collaboration, respect, and shared responsibility to achieve excellence in manufacturing, innovation, and customer service.",
    },
    {
      title: "Good Corporate Citizenship",
      image: corporateImg,
      description:
        "As a responsible organization, we are committed to ethical business practices, environmental responsibility, and contributing positively to society. We believe sustainable growth goes hand in hand with social responsibility.",
    },{
  title: "Innovation & Excellence",
  image: innovationImg,
  description:
    "We constantly adopt advanced technologies, modern manufacturing processes, and quality improvement practices to deliver superior automotive glass solutions.",
}
  ];

  return (
    <div>
      <Header />

      {/* Banner */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${ValuesBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="common_title wow fadeInUp">
            <h2>
              <Link
                to="/AboutUs"
                className="text-decoration-none text-white"
              >
                ABOUT US
              </Link>{" "}
              <span className="text-white">/ Our Values</span>
            </h2>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="container py-5">
        <div className="text-center mb-5">
          <h2
            style={{
              color: "#153fa4",
              fontSize: "42px",
              fontWeight: "700",
            }}
          >
            Our Values
          </h2>
          <p>
            The principles that guide Khodiyar Industries in delivering quality,
            trust, and excellence.
          </p>
        </div>

        <div className="row">
          {values.map((value, index) => (
            <div
              className="col-lg-4 col-md-6 mb-4 wow fadeInUp"
              key={index}
            >
              <div
                className="card border-0 shadow h-100"
                style={{ borderRadius: "15px" }}
              >
                <img
                  src={value.image}
                  alt={value.title}
                  className="card-img-top"
                  style={{
                    height: "250px",
                    objectFit: "cover",
                    borderRadius: "15px 15px 0 0",
                  }}
                />

                <div className="card-body">
                  <h4
                    style={{
                      color: "#153fa4",
                      fontWeight: "700",
                    }}
                  >
                    {value.title}
                  </h4>

                  <p>{value.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurValues;
